module.exports = __webpack_public_path__ + "img/service-icon.65a55cb6.png";